import { useCallback, useEffect, useRef, useState } from "react";
import outbox from "../services/attendanceOutbox";

/**
 * Status antrean absen untuk UI: item yang menunggu dikirim, yang gagal permanen,
 * dan penanda singkat "baru terkirim". Aksi: kirim sekarang, tutup item gagal.
 */
export default function useOutbox() {
  const [items, setItems] = useState([]);
  const [sending, setSending] = useState(false);
  const [justSent, setJustSent] = useState(0);
  const sentTimer = useRef(null);

  const refresh = useCallback(async () => {
    setItems(await outbox.listForCurrentUser());
  }, []);

  useEffect(() => {
    refresh();
    const onChange = () => refresh();
    const onSent = (e) => {
      setJustSent(e.detail?.count || 1);
      clearTimeout(sentTimer.current);
      sentTimer.current = setTimeout(() => setJustSent(0), 5000);
    };
    window.addEventListener("hris:outbox-changed", onChange);
    window.addEventListener("hris:outbox-sent", onSent);
    return () => {
      window.removeEventListener("hris:outbox-changed", onChange);
      window.removeEventListener("hris:outbox-sent", onSent);
      clearTimeout(sentTimer.current);
    };
  }, [refresh]);

  const flushNow = useCallback(async () => {
    setSending(true);
    try {
      await outbox.flush({ force: true });
    } finally {
      setSending(false);
      refresh();
    }
  }, [refresh]);

  const dismiss = useCallback(async (id) => {
    await outbox.dismiss(id);
    refresh();
  }, [refresh]);

  return {
    pending: items.filter((i) => i.status === "pending"),
    failed: items.filter((i) => i.status === "failed"),
    justSent,
    sending,
    flushNow,
    dismiss,
  };
}
